import { useCallback } from "react";
import { AddressBookOrder, ExactPaySlippageTypes } from "../types";
import { EXACT_PAY_MAX_SLIPPAGE_MAP } from "../constants/slippage";
import {
  initExactPayFields,
  useCreateSwapRequestContext,
} from "../context/CreateSwapRequestContext";

interface UseFormFieldsProps {
  fields: any;
  setFields: (fields: any) => void;
  initFields?: any;
  quoteFields?: string[];
}

export const useFormFields = ({
  fields,
  setFields,
  initFields = initExactPayFields,
  quoteFields = ["estimateAmount", "exchangeRate", "getMin"],
}: UseFormFieldsProps) => {
  const updateWalletAddress = useCallback(
    (name: keyof AddressBookOrder, value: string) => {
      if (name === "to_address" || name === "rawItem") {
        return setFields((prevFields: any) => ({
          ...prevFields,
          ...(name === "to_address" && {
            walletAddress: value,
            addressBookOrder: {
              ...prevFields.addressBookOrder,
              [name]: value,
            },
            ...(value === "" ? { balance: "", rawWalletInfo: null } : {}),
          }),
          ...(name === "rawItem" && {
            rawWalletInfo: value,
          }),
        }));
      }
    },
    [setFields]
  );

  const updateAmount = useCallback(
    (value: string, amountField: string = "exactPayAmount") => {
      const newFields = {
        ...fields,
        [amountField]: value,
      };

      // compare snapshot - clear quote details when changed
      if (
        fields.amountSnapShot &&
        fields.amountSnapShot.exactAmount !== value
      ) {
        quoteFields.forEach((quoteField: string) => {
          newFields[quoteField] = "";
        });
      }

      setFields(newFields);
    },
    [fields, setFields, quoteFields]
  );

  const clearQuoteFields = useCallback(() => {
    const clearedFields = { ...fields };
    quoteFields.forEach((quoteField: string) => {
      clearedFields[quoteField] = "";
    });
    setFields(clearedFields);
  }, [fields, setFields, quoteFields]);

  return {
    updateWalletAddress,
    updateAmount,
    clearQuoteFields,
  };
};
